// extracted by mini-css-extract-plugin
export var link = "_vi-0";